<template>
    <div class="page">
    <ion-grid>
      <ion-row class="search-view">
        <ion-col>
          <ion-row align-items-stretch>
             <ion-col size="12" size-md="3">
              <ion-label>Corporate Name</ion-label>
              <div class="border-line-34 readonly margin-top-10">
                <ion-input
                  class="form-input "
                  type="text"
                  id="corporateName"
                  @input="corporateName = $event.target.value"
                  maxlength="100"
                  :value= corporateName
                  readonly= "true"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Branch Name</ion-label>
              <div class="border-line-34 readonly margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="branch"
                  @input="branch = $event.target.value"
                  maxlength="100"
                  :value= branch
                  readonly="true"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Branch ID</ion-label>
              <div class="border-line-34 readonly margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="branchId"
                  @input="branchId = $event.target.value"
                  maxlength="50"
                  :value= branchId
                  readonly= "true"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Station Name</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="stationName"
                  @input="stationName = $event.target.value"
                  maxlength="100"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Address</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="city"
                  @input="city = $event.target.value"
                  maxlength="100"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Status</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-select
                  class="form-select select-mobile"
                  :value="status"
                  @ionChange="status = $event.target.value"
                  placeholder="Select Status"
                  interface="action-sheet"
                >
                  <ion-select-option
                    v-for="(status, index) in this.statuses"
                    :key="index"
                    :value="status.id"
                  >{{status.name}}</ion-select-option>
                </ion-select>

                <select
                  class="input-select select-web"
                  v-model="status"
                  placeholder="Select Status"
                >
                  <option
                    v-for="(status, index) in this.statuses"
                    :key="index"
                    :value="status.id"
                  >{{ status.name }}</option>
                </select>
              </div>
            </ion-col>
            <ion-col size="12" size-md="4">
              <br />
              <ion-button class="btn-search margin-top-10" @click="searchCPOBranches">Search</ion-button>
              <ion-button class="btn-clear margin-top-10" @click="clearFields">
                <ion-icon :icon="refresh"></ion-icon>
              </ion-button>
            </ion-col>
            
            <!-- <ion-col size="12" size-md="2">
              <br />
              <ion-button class="btn-search margin-top-10" @click="searchCPOBranches">Search</ion-button>
              <ion-button class="btn-clear margin-top-10" @click="clearFields">
                <ion-icon name="refresh"></ion-icon>
              </ion-button>
            </ion-col> -->
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row class="list-view">
        <ion-col>
          <ion-row class="list-head">
             <ion-col size="12" size-md="">
              <ion-label>Station ID</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <ion-label>Station Name</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <ion-label>City</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <ion-label>Effective From</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <ion-label>Last Effective Date</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <ion-label>Station Status</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <ion-label>Station Branch Effective From</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <ion-label>Station Branch Last Effective Date</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <ion-label>Station Branch Status</ion-label>
            </ion-col>
          </ion-row>
          <hr />

          <ion-row class="list-item" v-for="(station) in this.stations" :key="station">
            <ion-col size="12" size-md="">
              <ion-label class="ext-link" @click="viewStationDetails(station)">{{station.stationId}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="" style="cursor: pointer;" @click="addStationNameInFilter(station.stationName)">
              <ion-label>{{station.stationName}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="" style="cursor: pointer;" @click="addCityInFilter(station.city)">
              <ion-label>{{station.city}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <!-- <ion-label>{{ station.effectiveDate | dateFormat('DD/MMM/YYYY')}}</ion-label> -->
              <ion-label>{{ changeDateFormatWithoutTime(station.effectiveDate) }}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <!-- <ion-label>{{ station.lastEffectiveDate | dateFormat('DD/MMM/YYYY')}}</ion-label> -->
              <ion-label>{{ changeDateFormatWithoutTime(station.lastEffectiveDate) }}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <!-- <ion-label v-bind:class="[{'active': station.stationStatus.code == 'A'}, {'in-active': station.stationStatus.code == 'RET'}]">{{station.stationStatus.description | uppercase}}</ion-label> -->
              <!-- <ion-label v-bind:class="[{'active': station.stationStatus.code == 'A'}, {'greenfield': station.stationStatus.code == 'G'}, {'in-active': station.stationStatus.code == 'I'}, {'extinct': station.stationStatus.code == 'X'}]">{{station.stationStatus.description | uppercase}}</ion-label> -->
              <ion-label v-bind:class="[{'active': station.stationStatus.code == 'A'}, {'greenfield': station.stationStatus.code == 'G'}, {'in-active': station.stationStatus.code == 'I'}, {'extinct': station.stationStatus.code == 'X'}]">{{ convertUppercase(station.stationStatus.description) }}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <!-- <ion-label>{{ station.stationBranchEffectiveDate | dateFormat('DD/MMM/YYYY')}}</ion-label> -->
              <ion-label>{{ changeDateFormatWithoutTime(station.stationBranchEffectiveDate) }}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <!-- <ion-label>{{ station.stationBranchLasteffectiveDate | dateFormat('DD/MMM/YYYY')}}</ion-label> -->
              <ion-label>{{ changeDateFormatWithoutTime(station.stationBranchLasteffectiveDate) }}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <!-- <ion-label v-bind:class="[{'active': station.stationBranchStatus.code == 'A'}, {'in-active': station.stationBranchStatus.code == 'I'}]">{{ station.stationBranchStatus.description | uppercase}}</ion-label> -->
              <ion-label v-bind:class="[{'active': station.stationBranchStatus.code == 'A'}, {'in-active': station.stationBranchStatus.code == 'I'}]">{{ convertUppercase(station.stationBranchStatus.description) }}</ion-label>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row v-if="norecordsfound">
        <ion-col size="12" class="ion-text-center">
          <ion-label class="pagination-info">No records found for the selected filters</ion-label>
        </ion-col>
      </ion-row>
      <ion-row v-else>
        <ion-col size="12" size-md="5">
          <ion-label
            class="pagination-info"
          >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
        </ion-col>
        <ion-col size="12" size-md="7" class= "ion-text-right" >
          <div class="pagination">
            <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
            <a class="prev disabled" v-else>Prev</a>
            <a
              v-for="page in this.pagesList"
              :key="page"
              v-bind:class="{'active': pageNo == page}"
              @click="loadPage(page)"
            >{{page}}</a>
            <a
              class="next"
              v-if="this.pageNo < this.totalPages"
              @click="loadPage(pageNo + 1)"
            >Next</a>
            <a class="next disabled" v-else>Next</a>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { EVCStationService } from "../../service/evcstation/stations.service";
import { CorporateService } from "../../service/corporate/corporate.service";
import { PaginationUtils } from "../../util/pagination-utils";
import { EVCStationStatus } from "../../entity/location/evcstation";
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
import { refresh } from 'ionicons/icons';
import moment from "moment";

export default defineComponent ({
  name: 'cpoChargingStations',
  components: {
    IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSelect, IonSelectOption, IonButton, IonIcon, IonSpinner
  },
  data() {
    return {
      refresh,
      loaderTab: true,
      stations: [],
      statuses: [],
      corporateId: "",
      corporateName: "",
      branch: "",
      branchId: "",
      stationName: "",
      city: "",
      status: "",
      norecordsfound: true,
      totalRecords: 0,
      pageRecords: 15,
      pageNo: 1,
      pagesList: [],
      totalPages: 0
    }
  },
  async mounted() {
    var branchInfo = JSON.parse(localStorage.getItem('branchInfo'));
    if(branchInfo) {
      this.fillBranchDetails(branchInfo);
    }
    this.statuses = await new EVCStationService().stationStatuses();
    this.statusModels = [];
    this.statuses.forEach(status => {
    this.statusModels.push({
      text: status.name,
      value: status.id
    });
    });

    var page = localStorage.getItem('chargingStationPage');
      if (page) {
        this.pageNo = Number(page);
      }
      var search = localStorage.getItem('chargerSearch');
      if (search) {
        search = JSON.parse(search);
        this.stationName = search.stationName;
        this.city = search.city;
        document.getElementById("stationName").value = search.stationName;
        document.getElementById("city").value = search.city;
        this.status = search.status;

        this.searchCPOBranches();
      }
    
  },
  methods: {
    addStationNameInFilter(name) {
      document.getElementById('stationName').value = name;
      this.stationName = name;
    },
    addCityInFilter(city) {
      document.getElementById('city').value = city;
      this.city = city;
    },
    changeDateFormatWithoutTime(dateValue) {
      if(dateValue != null) {
        return moment(dateValue).format('DD/MMM/YYYY')
      }
    },
    convertUppercase(value) {
      return value.toUpperCase()
    },
    fillBranchDetails(branchDetails) {
      this.corporateName = branchDetails.corporateName;
      this.corporateId = branchDetails.corporateId;
      this.branch = branchDetails.branch;
      this.branchId = branchDetails.branchId;
      this.loaderTab = false
    },
    async searchCPOBranches() {
      let searchFilterData = {
          stationName: this.stationName,
          city: this.city,
          status: this.status,
      }
      localStorage.setItem("chargerSearch",JSON.stringify(searchFilterData));
      // this.pageNo = 1;
      localStorage.setItem("chargingStationSearch", JSON.stringify({corporateName: this.corporateName, id: this.branchId,  branch: this.branch}))
      this.loaderTab = true;
      let result = await new CorporateService().cpoChargingStationsAtPageByPaginatedWithSizeMatchingQuery(
        this.pageNo,
        this.pageRecords,
        {
          corporateId: this.corporateId,
          corporateName: this.corporateName,
          branchId: this.branchId,
          branch: this.branch,
          stationName: this.stationName,
          city: this.city,
          status:  new EVCStationStatus(this.status, "")
        }
      );
      if(result.data.length != 0) {
        this.totalRecords = result.meta.totalrecords;
        this.stations = result.data;
        (this.pagesList = new PaginationUtils().getPagesList(
        this.totalRecords,
        this.pageRecords,
        this.pageNo
        )),
        (this.totalPages = new PaginationUtils().getTotalPages(
        this.totalRecords,
        this.pageRecords
        ));
        this.norecordsfound = false;
        this.loaderTab = false;
      } else {
        this.stations = [];
        this.norecordsfound = true;
        this.loaderTab = false;
      }
    },
    async loadPage() {
      localStorage.setItem('chargingStationPage', page);
      this.loaderTab = true;
      this.pageNo = page;
      this.pagesList = new PaginationUtils().getPagesList(
        this.totalRecords,
        this.pageRecords,
        page
      );
      let result = await new CorporateService().cpoChargingStationsAtPageByPaginatedWithSizeMatchingQuery(
        this.pageNo,
        this.pageRecords,
        {
          corporateId: this.corporateId,
          corporateName: this.corporateName,
          branchId: this.branchId,
          branch: this.branch,
          stationName: this.stationName,
          city: this.city,
          status:  new EVCStationStatus(this.status, "")
        }
      );
      if(result.data.length != 0) {
        this.totalRecords = result.meta.totalrecords;
        this.stations = result.data;
        (this.pagesList = new PaginationUtils().getPagesList(
        this.totalRecords,
        this.pageRecords,
        this.pageNo
        )),
        (this.totalPages = new PaginationUtils().getTotalPages(
          this.totalRecords,
          this.pageRecords
        ));
        this.norecordsfound = false;
        this.loaderTab = false;
      } else {
        this.stations = [];
        this.norecordsfound = true;
        this.loaderTab = false;
      }
    },
    clearFields() {
      this.stationName = null;
      this.city = null;
      this.status = null;
      document.getElementById("stationName").value = null;
      document.getElementById("city").value = null;
      localStorage.removeItem('chargingStationSearch');
      localStorage.removeItem('chargingStationPage');
      this.stations = [];
      this.norecordsfound = true;
    },
    viewStationDetails(station) {
      localStorage.setItem('branchStationInfo', JSON.stringify(station));
      this.$router.push({
        name: "chargingStationView",
        params: { stationId: station.stationId }
      });
    }
  }
})
</script>